import axios from "axios";
import { LOGIN } from "../routes";
import {
  POST_LOGIN_STORAGE_KEY,
  STORE_LOCAL_STORAGE_KEY,
  TOKEN_STORAGE_KEY,
} from "../constants";
import { LocalStoreType } from "./types/types";

export const getNumberOfSlidesPerView = (aspectRatio: number) => {
  const numberOfTiles = 6; // It can be changeable.
  const slidesPerView =
    (aspectRatio >= 6
      ? 4
      : aspectRatio >= 2
      ? 3
      : aspectRatio === 1
      ? 5
      : aspectRatio >= 1
      ? numberOfTiles / aspectRatio
      : aspectRatio < 0.3
      ? 12
      : aspectRatio < 0.9 && aspectRatio > 0.8
      ? 8
      : numberOfTiles * (aspectRatio + 0.4)) || 2;
  return slidesPerView;
};

export const setPostLoginData = (data = null) => {
  if (!data && localStorage) {
    localStorage.removeItem(POST_LOGIN_STORAGE_KEY);
  }
};
export const setAxiosAuthHeaders = (token?: string, workspaceId?: string) => {
  if (token && workspaceId) {
    axios.defaults.headers.common = {
      Authorization: `Token ${token}`,
      Organization: workspaceId,
    };
  } else if (token && workspaceId == null) {
    axios.defaults.headers.common = {
      Authorization: `Token ${token}`,
    };
    delete axios.defaults.headers.common["Organization"];
  } else {
    // Delete auth header
    delete axios.defaults.headers.common["Authorization"];
    delete axios.defaults.headers.common["Organization"];
  }
};

export const setAxiosWorkspaceHeader = (workspaceId: string) => {
  if (workspaceId) {
    axios.defaults.headers.common = {
      ...axios.defaults.headers.common,
      Organization: workspaceId,
    };
  } else {
    delete axios.defaults.headers.common["Organization"];
  }
};

export const getAuthToken = () => localStorage.getItem(TOKEN_STORAGE_KEY);

export const setAuthToken = (token?: string) => {
  if (token) {
    localStorage.setItem(TOKEN_STORAGE_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
  }
};

export const logoutUser = (redirectUrl: string = LOGIN) => {
  // Remove token from local storage
  setAuthToken();

  // Remove auth header for future requests
  setAxiosAuthHeaders();

  // Clear redux persist
  // clearPersistedStore();

  if (window) {
    window.location.href = redirectUrl;
  }
};

export const loadStore = (): LocalStoreType | undefined => {
  try {
    const serializedStore = localStorage.getItem(STORE_LOCAL_STORAGE_KEY);
    if (serializedStore === null) {
      return undefined;
    }
    return JSON.parse(serializedStore);
  } catch (err) {
    return undefined;
  }
};

export const shimmer = (w: number, h: number) => `
<svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="#333" offset="20%" />
      <stop stop-color="#222" offset="50%" />
      <stop stop-color="#333" offset="70%" />
    </linearGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="#333" />
  <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
  <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"  />
</svg>`;

export const toBase64 = (str: string) =>
  typeof window === "undefined"
    ? Buffer.from(str).toString("base64")
    : window.btoa(str);

export const imagePlaceHolderShimmer = (width: number, height: number): string => {
  return `data:image/svg+xml;base64,${toBase64(
    shimmer(width, height)
  )}`
}

export const isMobileView = (): boolean => {
  if (window.innerWidth < 768) {
    return true;
  } else {
    return false;
  }
};

export const openUrl = (url: string, target?: string) => {
  if (!isMobileView()) {
    const win = window?.open(url, target);
    if (win) window?.focus();
  } else {
    window.location.href = url;
  }
};

export const duplicateArrayContents = (array: any[], count: number): any[] => {
  const duplicatedArray = [...array];
  for (let i = 0; i < count; i++) {
    for (const value of array) {
      duplicatedArray.push(value);
    }
  }
  return duplicatedArray;
};
